<template>
  <div class="view-stock h-100">
    <b-container fluid class="h-100">
    <b-row>
      <b-col sm="3">
        <h2>Hidden Gem</h2>
      </b-col>
      <b-col sm="3">
        <b-form-input 
          v-model="stockCode" 
          placeholder="Enter stock code here" 
          v-on:keyup.enter="getStock()" 
        />
        <b-alert v-model="stockCodeNOK" variant="danger" dismissible>
          {{errorMessage}}
        </b-alert>
      </b-col>
      <b-col sm="1">
        <b-button 
          id="btn-search" 
          v-show="!isLoading" 
          v-on:click="getStock()" 
        >
          Search
        </b-button>
        <b-spinner v-show="isLoading" label="Loading..."></b-spinner>
      </b-col>
      <b-col sm="1">
        <b-button v-b-modal.confirm-clear variant="light">Clear</b-button>
        <b-modal id="confirm-clear" @ok="clear()">
          
          <div class="d-block text-center">
            This action cannot be reversed. Are your sure?
          </div>          
        </b-modal>
      </b-col>
      <b-col sm="4">
        <b-button v-b-modal.set-api-key v-show="false" :variant="getSetApiVariant">{{this.apiKey ? 'Api Key Set!' : 'Set Api Key'}}</b-button>
        <b-modal id="set-api-key" size="sm" title="Enter API Keys">
          <template v-slot:default>
            <div class="d-block text-center">
              <b-form-input 
                v-model="apiKeyTemp" 
                placeholder="Enter api key here" 
                v-on:keyup.enter="setApiKey()" 
              />
            </div>
          </template>
          <template v-slot:modal-footer>
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <b-button size="sm" variant="primary" @click="setApiKey()">
              OK
            </b-button>
            <b-button size="sm" variant="secondary" @click="cancelApiKey()">
              Cancel
            </b-button>
            <!-- Button with custom close trigger value -->
            <b-button size="sm" variant="danger" @click="clearApiKey()">
              Clear
            </b-button>
          </template>
        </b-modal>
      </b-col>
    </b-row>
    <b-table sticky-header striped hover :items="items" :fields="fields" style="max-height: 100%"></b-table>
    <table class="table-borderless"><td class="table-warning"><strong>Name</strong></td><td> = has insufficient year data</td></table>
    
  </b-container>

  
  </div>
</template>
<style>
  #btn-search {
    background-color: #FC6600;
  }
</style>
<script>
import Humanize from 'humanize-plus';
import { ApiService } from '../services/ApiService';

const apiService = new ApiService();

export default {
  name: 'ViewStock',
  data() {
    return {
      apiKey: null,
      apiKeyTemp: null,
      stickyHeader: true,
      isLoading: false,
      fields: [
        { key: 'name', stickyColumn: true, isRowHeader: true, sortable: true },
        { key: 'code', sortable: true },
        { key: 'industry', sortable: false },
        { key: 'subsector', sortable: false },
        { key: 'avgRoe', sortable: false },
        { key: 'debtEquityRatio', sortable: false },
        { key: 'debtEquityRatioAdj', sortable: false },
        { key: 'avgEpsGrowth', sortable: false },
        { key: 'rolling4qPe', sortable: false, label: 'Rolling 4Q PE' },
        { key: 'avgPe', sortable: false, label: 'Avg PE' },
        { key: 'closingPrice', sortable: false },
        { key: 'fairValueDiscounted', sortable: false },
        { key: 'fairValue33', sortable: false },
        { key: 'intrinsicValue', sortable: false },
        { key: 'earningPs', sortable: false },
        { key: 'wk52Low', sortable: false, label: 'Wk52 Low' },
        { key: 'wk52High', sortable: false, label: 'Wk52 High'  },
        { key: 'currentPe', sortable: false },
        { key: 'netProfit', sortable: false },
        { key: 'rolling4qEps', sortable: false },
        { key: 'totalShareholdersFund', sortable: false },
        { key: 'latestRoe', sortable: false },
        { key: 'avgDivPayout', sortable: false },
        // { key: 'eps', sortable: false },
        { key: 'totalProjectedEps', sortable: false },
        { key: 'priceAt11yr', sortable: false },
        { key: 'totalDiv', sortable: false },
        { key: 'totalReturn', sortable: false },
        // { key: 'hasLastYearROE', sortable: false },
        // { key: 'hasLastYearPE', sortable: false },
      ],
      items: [],
      stockCode: '',
      stockCodeNOK: false,
      errorMessage: '',
    };
  },
  computed: {
    getSetApiVariant() {
      return this.apiKey ? 'success' : 'danger';
    }
  },
  methods: {
    roundToDecimal(value, decimal) {
      return Math.round(value * 10 ** decimal) / 10 ** decimal;
    },
    setApiKey() {
      this.apiKey = this.apiKeyTemp;
      this.$bvModal.hide('set-api-key');
    },
    cancelApiKey() {
      this.apiKeyTemp = this.apiKey;
      this.$bvModal.hide('set-api-key');
    },
    clearApiKey() {
      this.apiKey = null;
      this.apiKeyTemp = null;
    },
    async getStock() {
      // if (!this.apiKey) {
      //   this.errorMessage = 'Please set api key'; 
      //   this.stockCodeNOK = true;
      //   return;
      // }
      // let usedCount = 0;
      // if (localStorage.usedCount) {
      //   usedCount = parseInt(localStorage.usedCount);
      // } 
      // if (usedCount > 3) {
      //   console.log('Limit reached. ' + usedCount);
      //   this.errorMessage = 'Limit reached. Please contact JAdvisory';
      //   this.stockCodeNOK = true;
      //   return;
      // }
      if (this.stockCode.length === 0) {
        this.errorMessage = 'Enter at least 1 stock code'; 
        this.stockCodeNOK = true;
        return;
      }
      if(this.stockCode.split(',').length > 3){
        this.errorMessage = 'Enter at most 3 stock code'; 
        this.stockCodeNOK = true;
        return;
      }
      this.stockCodeNOK = false;
      this.isLoading = true;
      try {
        const data = await apiService.getStock(this.stockCode, this.apiKey);
        // localStorage.usedCount = usedCount + 1;
        // console.log(data);
        this.items.push(... data);
        for(const d of data) {
          Object.keys(d).forEach(k => {
            if(typeof d[k] === "number") {
              if(d[k] > 1000) {
                d[k] = Humanize.compactInteger(d[k], 2);
              } else {
                d[k] = Humanize.formatNumber(d[k], 2);
              }
            }
          });
          if (d.isPartialData) {
            d._cellVariants = { name: 'warning' };
          }
        }
        this.isLoading = false;
        this.stockCode = '';
      } catch (err) {
        console.error(err.response);
        this.stockCodeNOK = true;
        const errMsg = err.response.data.message;
        if (errMsg === 'Forbidden') {
          this.errorMessage = 'Invalid api key';
        } else if (errMsg === 'Limit Exceeded') {
          this.errorMessage = 'Limit exceeded. Please consider subscribing to get unlimited access';
        } else {
          this.errorMessage = 'Oppss something went wrong. Please try again later or contact JAdvidory';
        }
        this.isLoading = false;
      }
    },
    clear() {
      this.items = [];
    }
  },
  
}
</script>
